<!--
  <GoBackButton :to="{ name: 'Search' }" default="/sok/bostad"/>
-->
<template>
  <div>
    <router-link
      v-if="rentalObjectCode"
      class="btn btn-primary"
      :to="{ name: 'Vacancy', params: { id: rentalObjectCode } }">
      <template v-if="type == 'next'">Nästa</template>
      <template v-else>Förra</template>
    </router-link>
    <a v-else class="btn btn-primary disabled" href="#">
      <template v-if="type == 'next'">Nästa</template>
      <template v-else>Förra</template>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    current: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    rentalObjectCode() {
      let rentalObject = null;

      if (this.type == 'next') {
        rentalObject = this.$store.getters.getNextRentalObjectFromSearchResult(this.current);
      } else {
        rentalObject = this.$store.getters.getPreviousRentalObjectFromSearchResult(this.current);
      }

      if (rentalObject) return '' + rentalObject.rentalObjectCode;
    },
  },
};
</script>
